<template>
  <div class="aboutus">
    <navBar :noBackIcon="true" pageTitle="关于我们" :showTryOut="false" :showMenu="false" />
    <div class="s-banner" :style="{backgroundImage: 'url(' + bannerUrl + ')'}" />
    <!--教材tab栏切换-->
    <div ref="navBox" :class="['nav-box', tabFixed ? 'isFixed' :'']">
      <ljTab
        v-model="selectedId"
        :items="tabItems"
        :options="options"
        @click.native="changeSelect"
      />
    </div>
    <!--教材内容列表-->
    <div ref="contentRef" class="a-content">
      <div v-if="selectedId===0" class="introduce">
        <p>CC英语自1995年成立至今，26年始终专注英语教学与研究，现有40余所直营校，开设从幼儿零基础入门至雅思的全系列英语课程，一直以来倍受家长和学生的信赖。</p>
        <p>在20余年丰厚教学沉淀基础上，CC英语已经成功研发各类教材匹配学习地图、《Easy English with Civa》系列教材120余册、Civa教师中心、Civa机器人App等全产品体系。</p>
        <p>CC英语在坚持直营发展的同时，发展对外加盟品牌Civa，专业向教育机构输出以教材为依托、以学习地图为核心的课程内容，以及匹配直达终端课堂的训练方式、精准的教学管理等一整套教学管理服务体系，服务全国加盟校近2000家。</p>
        <p>我们致力于为广大教育机构提供高效的教育服务，为每一个学生、家长提供完善、有效、物有所值的教育服务。</p>
        <p style="font-weight: bold;">期待您的加入，让“教书”不再是难事，让“育人”成为教育的核心！</p>
      </div>
      <!-- <div v-if="selectedId===1 || selectedId===2" class="history">
        <div v-for="list in historyHonor" :key="list.id" class="h-content">
          <div class="h-con-step">
            <div class="h-circle" />
          </div>
          <div class="h-con">
            <h5 class="his-title">
              {{ list.year }}
            </h5>
            <div v-for="(item,index,key) in list.eventList" :key="key" class="h-content-item civa-border-bot" @click="goCaseDetails(item)">
              <div class="his-img" :style="{backgroundImage: 'url('+ item.picUrl+')'}" />
              <p class="his-intro">
                {{ item.content }}
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="selectedId===3" class="contact"> -->
      <div v-if="selectedId===1" class="contact">
        <div class="contact-map">
          <el-amap vid="map" :zoom="myMap.zoom" :center="myMap.center">
            <a class="look-map" href="https://uri.amap.com/marker?position=106.7191560000,26.5654460000&name=贵州省贵阳市纪念塔国恩大厦1-3F">查看详细路线</a>
            <el-amap-marker :position="marker.position" :icon="marker.icon" />
          </el-amap>
        </div>
        <div class="contact-addr">
          <div class="addr">
            <img class="img-addr" src="https://restaskimg.civaonline.cn/imagesH5/other/address-icon.png" alt="">贵州省贵阳市纪念塔国恩大厦1-3F
          </div>
          <div class="addr mar-t12">
            <img class="img-addr" src="https://restaskimg.civaonline.cn/imagesH5/other/tel-icon.png" alt=""><a href="tel:400-9699-200">400-9699-200</a>
          </div>
        </div>
        <div class="contact-map">
          <el-amap vid="amap" :zoom="myMap1.zoom" :center="myMap1.center">
            <a class="look-map" href="https://uri.amap.com/marker?position=120.1251790000,30.2767070000&name=西湖区文三西路478号华星时代广场A座1101">查看详细路线</a>
            <el-amap-marker vid="marker" :position="marker1.position" :icon="marker1.icon" />
          </el-amap>
        </div>
        <div class="contact-addr">
          <div class="addr2">
            <img class="img-addr" src="https://restaskimg.civaonline.cn/imagesH5/other/address-icon.png" alt="">
            <p>浙江省杭州市西湖区文三西路478号华星时代广场A座1203</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
import navBar from '@/components/navBar';
import ljTab from '@/components/tabs/';
import hisData from '@/data/history'
import honorData from '@/data/honorRoll'
export default {
  components: {
    ljTab, navBar,
  },
  data() {
    return {
      myMap: {
        zoom: 16,
        center: [106.7191560000, 26.5654460000],
      },
      marker: {
        position: [106.7191560000, 26.5654460000],
        icon: 'http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
      },
      myMap1: {
        zoom: 16,
        center: [120.1251790000, 30.2767070000],
      },
      marker1: {
        position: [120.1251790000, 30.2767070000],
        icon: 'http://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
      },
      selectedId: 0,
      tabItems: [
        {
          name: '公司介绍',
          id: '1',
        },
        // {
        //   name: '发展历程',
        //   id: '2',
        // },
        // {
        //   name: '荣誉榜',
        //   id: '3',
        // },
        {
          name: '联系我们',
          id: '4',
        },
      ],
      tabFixed: false,
      options: {
        activeTextColor: '#293340',
        activeColor: '#FF7500',
        labelKey: 'name',
        // 可在这里指定labelKey为你数据里文字对应的字段
      },
      historyHonor: [],
      bannerUrl: '',
    }
  },
  created() {
    VueAMap.initAMapApiLoader({
      key: '5ed9099a6c8470003c1898efb5cc0686',
      plugin: ['AMap.Autocomplete', 'AMap.Driving', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
      // 默认高德 sdk 版本为 1.4.4
      v: '1.4.4',
    });
  },
  mounted() {
    const selId = sessionStorage.getItem('civaSelectedId') || 0;
    this.selectedId = parseInt(selId);
    this.tabChange(this.selectedId);
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);// 监听页面滚动事件
  },
  methods: {
    tabChange(selectedId) {
      this.historyHonor = [];
      this.historyHonor.length = 0;
      if (selectedId === 1){ // 发展历程
        this.bannerUrl = 'https://restaskimg.civaonline.cn/imagesH5/aboutus/banner2.png';
        this.$nextTick(() => {
          this.historyHonor = hisData.result;
        });
      } else if (selectedId === 2){ // 荣誉榜
        this.bannerUrl = 'https://restaskimg.civaonline.cn/imagesH5/aboutus/banner3.png';
        this.$nextTick(() => {
          this.historyHonor = honorData.result;
        });
      } else if (selectedId === 3){
        this.bannerUrl = 'https://restaskimg.civaonline.cn/imagesH5/aboutus/banner4.png';
      } else this.bannerUrl = 'https://restaskimg.civaonline.cn/imagesH5/aboutus/banner1.png';
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const offsetTop = this.$refs.contentRef.offsetTop;
      const hiddenNav = this.$refs.navBox.offsetHeight;
      scrollTop + hiddenNav > offsetTop ? this.tabFixed = true : this.tabFixed = false;
    },
    changeSelect() {
      this.tabChange(this.selectedId);
      sessionStorage.setItem('civaSelectedId', this.selectedId);
    },
  },
}
</script>

<style scoped lang="less">
    .aboutus{
        .s-banner{
            margin-bottom: 50px;
            background-color: #fff;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
        }
        .a-content{
            padding: 80px 0 160px;
            .introduce{
                padding: 0 32px;
                p{
                    line-height: 50px;
                    margin-bottom: 50px;
                }
            }
            .history{
                .h-content{
                    padding: 0 32px;
                    overflow: hidden;
                    display: flex;
                    .h-con-step{
                        width: 16px;
                        height: auto;
                        position: relative;
                        .h-circle{
                            width: 16px;
                            height: 16px;
                            box-sizing: border-box;
                            border-radius: 50%;
                            border: 4px solid #FF7501;
                            margin-top: 12px;
                        }
                    }
                    .h-con-step:after{
                        content: " ";
                        width: 2px;
                        height: 100%;
                        background: #E4E4E4;
                        position: absolute;
                        top: 35px;
                        left: 50%;
                        margin-left: -1px;
                    }
                    .h-con{
                        margin-left: 20px;
                    }
                    .his-title{
                        font-family: SyMedium;
                        font-size: 32px;
                        color: #333333;
                    }
                    .h-content-item{
                        width: 100%;
                        padding: 30px 0;
                        display: flex;
                        .his-img{
                            width: 248px;
                            height: 160px;
                            border-radius: 4px;
                            background-color: #E4E4E4;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-position: center;
                        }
                        .his-intro{
                            flex: 1;
                            margin-left: 24px;
                            color: #333333;
                            line-height: 40px;
                        }
                    }
                }
                .h-content:last-child .h-con-step:after{
                    width: 0;
                }
            }
            .contact{
                padding: 0 20px;
                .contact-map{
                    width: 100%;
                    height: 447px;
                  position: relative;
                  .look-map{
                    position: absolute;
                    right: 12px;
                    top: 12px;
                    background: #fff;
                    color: #293340;
                    font-size: 30px;
                    display: inline-block;
                    width: 200px;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                  }
                }
                .contact-addr{
                    padding: 0 12px 120px;
                    margin-top: 25px;
                    color: #333333;
                    .addr{
                        height: 40px;
                        display: flex;
                        align-items: center;
                        .img-addr{
                            width: 30px;
                            margin-right: 9px;
                        }
                        a{
                          color: #333333;
                        }
                    }
                    .mar-t12{
                        margin-top: 12px;
                    }
                    .addr2{
                        display: flex;
                        align-items: flex-start;
                        .img-addr{
                            width: 30px;
                            margin-top: 4px;
                            margin-right: 18px;
                        }
                    }
                }
            }
        }
    }
</style>
